<template>
  <b-dropdown :text="text" class="custom-dropdown">
    <div v-if="withSearch" class="p-2">
      <b-input placeholder="Search..." @input="filter" />
    </div>
    <b-dropdown-item
      v-for="(option, index) in optionsFiltered"
      :key="'option_' + index + option.value"
      @click="() => selectOption(option)"
    >
      {{ option.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'Dropdown',
  props: {
    options: {
      type: Array as () => SelectOptions[],
      default: () => [],
    },
    selectedOption: {
      type: String,
      default: null,
    },
    dropdownText: {
      type: String,
      default: '',
    },
    withSearch: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selected'],
  setup(props, { emit }) {
    const selected = ref(props.selectedOption)
    const text = ref(props.dropdownText)
    const optionsFiltered = ref<SelectOptions[]>(props.options)

    const selectOption = (option: SelectOptions) => {
      selected.value = String(option.value)
      text.value = option.text
      emit('selected', option)
    }

    const filter = (event: Event) => {
      const target = event.target as HTMLInputElement
      const searchText = target.value.toLowerCase()
      optionsFiltered.value = props.options.filter((option) => option.text.toLowerCase().includes(searchText))
    }

    return {
      text,
      optionsFiltered,
      selectOption,
      filter,
    }
  },
})
</script>
